<template>
  <div class="warp">
    <Detail :props-obj="propsObj" />
  </div>
</template>
<script>
import Detail from '@/views/module/moduleDetail/famousTeaSpecialarea/detail';
export default {
  name: 'TeacherDetail',
  components: {
    Detail
  },
  props: {
    propsId: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      propsObj: {
        link: 'searchResult'
      }
    };
  },
  watch: {
    propsId: {
      handler: function(val) {
        this.propsObj.propsId = val;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>
